import React, { useEffect, useState } from 'react';

import styles from './DogCardNotes.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import Card from '../../../../../Shared/Card/Card';
import { general } from '../../../../../../general';

function DogCardNotes(props: DogCardNotesProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [notes, setNotes] = useState<Array<any>>([]);

    const [creatingNote, setCreatingNote] = useState<boolean>(false);
    const [noteid, setNoteid] = useState<number | undefined>(undefined);
    const [noteTitle, setNoteTitle] = useState<string>("");
    const [noteContent, setNoteContent] = useState<string>("");

    function getNotes() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'post',
            url: "/api/restricted/notes/" + props.dogId,
            responseType: 'json',
            data: {},
            headers: {
                'x-access-token': auth.user['token'],
                "selected-country": auth.selectedCountry || "all",
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        }).then((res) => {
            setNotes(res.data);
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function createOrEditNote() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'put',
            url: "/api/restricted/notes/" + props.dogId,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
            data: {
                noteid: noteid,
                title: noteTitle,
                content: noteContent
            }
        }).then((res) => {
            setCreatingNote(false);
            setNoteid(undefined);
            setNoteTitle("");
            setNoteContent("");
            getNotes();
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function deleteNote(noteid: number) {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'delete',
            url: "/api/restricted/notes/" + props.dogId,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" },
            data: {
                noteid: noteid
            }
        }).then((res) => {
            getNotes();
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (props.dogId != undefined) {
            getNotes();
        }
    }, [props.dogId]);

    return (
        <div className={styles.dognotes}>
            <Card
                title={t('dog.notes.card.title')}
                children={<div>
                    <hr/>
                    <div className={styles.notes}>
                        {notes?.map((note, index) => {
                            return <div key={index} className={styles.note}>
                                <h5 className={styles.title}>{note.TITLE}</h5>
                                <p className={styles.content}>{note.CONTENT}</p>
                                {general.getBreedAccess(auth.user, auth.selectedBreed) == "admin" ?
                                    <div className={styles.editbutton}>
                                        <button onClick={() => {
                                            deleteNote(note.ID);
                                        }}>{
                                            t('dog.notes.card.deletenote')
                                        }</button>
                                        <button onClick={() => {
                                            setCreatingNote(true);
                                            setNoteid(note.ID);
                                            setNoteTitle(note.TITLE);
                                            setNoteContent(note.CONTENT);
                                        }}>{
                                            t('dog.notes.card.editnote')
                                        }</button>
                                    </div>
                                : null}
                            </div>
                        })}
                        {general.getBreedAccess(auth.user, auth.selectedBreed) == "admin" ?
                            <div className={styles.newnote}>
                                { !creatingNote ?
                                    <button onClick={() => {
                                        setCreatingNote(true);
                                        setNoteTitle("");
                                        setNoteContent("");
                                        setNoteid(undefined);
                                    }}>{
                                        t('dog.notes.card.newnote')
                                    }</button>
                                : null}
                                { creatingNote ? 
                                    <div className={styles.creatingnote + " " + styles.note}>
                                        <input
                                            className={styles.title}
                                            type="text"
                                            placeholder={t('dog.notes.card.newtitle')}
                                            value={noteTitle}
                                            onChange={(e) => setNoteTitle(e.target.value)}
                                        />
                                        <textarea
                                            placeholder={t('dog.notes.card.newcontent')}
                                            value={noteContent}
                                            onChange={(e) => setNoteContent(e.target.value)}
                                        />
                                        <div>
                                            <button
                                                style={{marginTop: "4px"}}
                                                onClick={() => {
                                                    setCreatingNote(false);
                                                    setNoteid(undefined);
                                                    setNoteTitle("");
                                                    setNoteContent("");
                                                }}
                                            >{t('dog.notes.card.cancel')}</button>
                                            <button
                                                style={{marginTop: "4px"}}
                                                onClick={() => createOrEditNote()}
                                            >{t('dog.notes.card.save')}</button>
                                        </div>
                                    </div>
                                : null}
                            </div>
                        : null}
                    </div>
                </div>}
            ></Card>
        </div>
    );
}

class DogCardNotesProps {
    title?: string;
    dogId!: string | undefined;
    onDataLoaded?: (data: any) => void;
}

export default DogCardNotes;